import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { createMask } from '@ngneat/input-mask';
import { fromEvent, Observable } from 'rxjs';
import { AuthState } from 'src/app/services/auth/auth.model';
import { ToastService } from 'src/app/services/toast/toast.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { debounceTime, distinctUntilChanged, filter, skipWhile, take, tap } from 'rxjs/operators';
import { ManageAdminsBLL } from '../manage-admins.bll';

@Component({
  selector: 'app-admins-modal',
  templateUrl: './admins-modal.component.html',
  styleUrls: ['./admins-modal.component.scss'],
})
export class AdminsModalComponent implements OnInit {

  groupForm: FormGroup;
  isLoading$: Observable<boolean>;
  updateGroupLoading$: Observable<boolean>;
  isAddAdminModelOpen$: Observable<boolean>;
  addGroupModal: boolean = false;
  updateAdminModal: boolean = false;
  user: AuthState;
  selectedContact: any;

  keyword_guardian: string;
  guardian: any;

  admin$: Observable<any>;



  adminInputMask = createMask<string>({
    inputType: 'number',
    mask: '(999)999-9999',
    placeholder: '(xxx)xxx-xxxx',
    positionCaretOnClick: 'select'
  });


  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    private bll: ManageAdminsBLL,
    private auth: AuthService
  ) {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required]],
      email: ['', [Validators.required]]

    });
  }

  ngOnInit() {
    this.bll.selectedContact$.subscribe(Contact => {
      if (Contact) {
        this.selectedContact = Contact
        this.name?.setValue(Contact.name ?? '');
        this.number?.setValue(Contact.number ?? '');
        this.email?.setValue(Contact.email ?? '');
      }
    })
    this.bll.isUpdateAdminModelOpen$.subscribe(isUpdate => {
      this.updateAdminModal = isUpdate;
    })

    this.isAddAdminModelOpen$ = this.bll.isAddAdminModelOpen$;
    this.auth.auth$.pipe(skipWhile((val) => !val.token), take(1))
      .subscribe((val) => {
        this.user = val;
        if (this.user.id) {
          this.initObservables();
        }
      });
  }

  getUsers() {
    this.bll.getAvailableAdmin(this.keyword_guardian);
  }

  proceedNextFor() {
    this.getUsers();
  }

  initObservables() {
    this.isLoading$ = this.bll.isLoading$;
    this.admin$ = this.bll.admin$;
  }

  resetModalState() {
    // this.groupForm.reset();
    this.keyword_guardian = '';
  }

  updateAdmin() {
    this.bll.editAdmin(
      this.selectedContact.id, this.groupForm.value
    );
    this.resetModalState()
    this.bll.changeUpdateAdminModelOpen(false);
    this.bll.toggleAddAdminModel(false);
  }

  createAdmin(admin) {
    console.log(admin);
    // return;
    this.bll.createAdmin(
      admin
    );
    this.resetModalState()
    this.bll.toggleAddAdminModel(false);
  }

  closeModel(isOpen: boolean) {
    this.bll.toggleAddAdminModel(isOpen);
    this.resetModalState()
    this.bll.changeUpdateAdminModelOpen(false);
  }

  //#region FORM GETTERS

  get name() {
    return this.groupForm.get('name');
  }

  get number() {
    return this.groupForm.get('number');
  }

  get email() {
    return this.groupForm.get('email');
  }

  //#endregion FORM GETTERS
  
}
